import React, { useEffect, useState, Suspense } from 'react';
import './ShopPayment.css';
import { Link, Navigate, useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import { IoMdArrowRoundBack } from "react-icons/io";
import { NumericFormat } from 'react-number-format';
import { useTelegram } from '../../../hooks/auth/useTelegram';
import CustomSelect from '../../../Components/CustomSelect/CustomSelect';
import { BankCardRecognizer } from '../../../hooks/BankCardRecognizer';
import config from '../../../config';
import api from '../../../hooks/api';
import { FaChevronDown } from "react-icons/fa6";
import { FaRegCopy } from "react-icons/fa6";
import StoreBanner from '../Shop/StoreBanner';
import TelegramSafeArea from '../../../Components/TelegramSafeArea';
import Swal from 'sweetalert2';
import isValidCardNumber from '../../StorePanel/StoreForm/components/validateCardNumber';

// مسیر استاندارد تصاویر از ریشه public
const PUBLIC_URL = process.env.PUBLIC_URL || '';
const card2cardIcon = `${PUBLIC_URL}/images/bankIcons/000000.png`;
const zarinpalIcon = `${PUBLIC_URL}/images/bankIcons/zarinpal_icon.png`;
const zibalIcon = `${PUBLIC_URL}/images/bankIcons/zibal_icon.png`;

// لود ناهمگام کامپوننت ثبت‌نام
const Register = React.lazy(() => import('../../Buyer/Register/Register'));

const themeColors = [
    { id: 1, title: "قرمز", code: "#D32F2F", text: "#000" },
    { id: 2, title: "سبز", code: "#388E3C", text: "#000" },
    { id: 3, title: "زرد", code: "#FBC02D", text: "#000" },
    { id: 4, title: "صورتی", code: "#C2185B", text: "#000" },
    { id: 5, title: "آبی", code: "#1976D2", text: "#000" },
    { id: 6, title: "بنفش", code: "#7B1FA2", text: "#000" },
    { id: 7, title: "نارنجی", code: "#E64A19", text: "#000" },
    { id: 8, title: "طوسی", code: "#212121", text: "#000" },
];

function ShopPayment() {
    const location = useLocation();

    const {
        address: passedAddress,
        postcode: passedPostcode,
        shippingMethod,
        shippingPaymentType,
        note: passedNote
    } = location.state || {};

    const [store, setStore] = useState(() => {
        try {
            const s = sessionStorage.getItem("store");
            return s ? JSON.parse(s) : null;
        } catch (e) { return null; }
    });

    const [cartItems, setCartItems] = useState(() => {
        try {
            const baskets = JSON.parse(localStorage.getItem("baskets") || "[]");
            return Array.isArray(baskets) ? (baskets.find((x) => x.id === store?.id)?.cartItems ?? []) : [];
        } catch (e) {
            return [];
        }
    });

    const [Address, setAddress] = useState(passedAddress || "");
    const [Postcode, setPostcode] = useState(passedPostcode || "");
    const [orderNote, setOrderNote] = useState(passedNote || "");

    const [paymentChoice, setPaymentChoice] = useState(0); // 1: Card, 2: Zarinpal, 3: Zibal

    // فیلدهای فرم کارت به کارت
    const [destinationCard, setDestinationCard] = useState("");
    const [payer, setPayer] = useState("");
    const [description, setDescription] = useState("");
    const [trackingCode, setTrackingCode] = useState("");
    const [sourceCard, setSourceCard] = useState(null);
    const [paymentClick, setPaymentClick] = useState(false);

    // وضعیت‌های سناریوی دریافت مجوز
    const [isCardToCardPermitted, setIsCardToCardPermitted] = useState(false);
    const [paymentHash, setPaymentHash] = useState(null);
    const [timer, setTimer] = useState(600);

    // وضعیت‌های مودال رسید و ثبت‌نام
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [receiptData, setReceiptData] = useState(null);
    const [isShowRegister, setIsShowRegister] = useState(false);

    // استیت‌های مربوط به درگاه‌ها و لودینگ
    const [cards, setCards] = useState([]);
    const [isGatewaysLoading, setIsGatewaysLoading] = useState(true);
    const [hasCardToCard, setHasCardToCard] = useState(false);
    const [hasZarinpal, setHasZarinpal] = useState(false);
    const [hasZibal, setHasZibal] = useState(false);

    const [options, setOptions] = useState([]);
    const [backgroundcolor, setBackgroundcolor] = useState(null);
    const [color, setColor] = useState(null);
    const [bgLight, setBgLight] = useState(null);
    const [chatId, setChatId] = useState(null);

    const { ChatId } = useTelegram();

    const hasAnyGateway = hasCardToCard || hasZarinpal || hasZibal;

    useEffect(() => {
        if (store?.theme_json) {
            try {
                const themeData = typeof store.theme_json === 'string' ? JSON.parse(store.theme_json) : store.theme_json;
                const colorId = themeData?.color_id;

                const selectedColor = themeColors.find(c => c.id === Number(colorId));

                if (selectedColor) {
                    setBackgroundcolor(selectedColor.code);
                    setColor(selectedColor.text);
                    setBgLight(`${selectedColor.code}1A`);
                }
            } catch (error) {
                console.error("خطا در پارس theme_json", error);
            }
        }
    }, [store]);

    // دریافت لیست درگاه‌های فعال فروشگاه
    useEffect(() => {
        if (store?.id) {
            setIsGatewaysLoading(true);
            api.post('business/payment/gateway/active', { business_id: store.id })
                .then(res => {
                    if (res.data.success) {
                        const gateways = res.data.data;

                        const cardGateway = gateways.find(g => g.transactionType_id === 1);
                        if (cardGateway && cardGateway.config) {
                            setHasCardToCard(true);
                            try {
                                const parsedConfig = typeof cardGateway.config === 'string'
                                    ? JSON.parse(cardGateway.config)
                                    : cardGateway.config;
                                setCards(Array.isArray(parsedConfig) ? parsedConfig : []);
                            } catch (e) {
                                setCards([]);
                            }
                        } else {
                            setHasCardToCard(false);
                            setCards([]);
                        }

                        const zarinGateway = gateways.find(g => g.transactionType_id === 2);
                        setHasZarinpal(!!zarinGateway);

                        const zibalGateway = gateways.find(g => g.transactionType_id === 3);
                        setHasZibal(!!zibalGateway);
                    }
                })
                .catch(err => {
                    console.error("خطا در دریافت درگاه‌های پرداخت:", err);
                    toast.error("خطا در دریافت روش‌های پرداخت فروشگاه", { rtl: true });
                })
                .finally(() => {
                    setIsGatewaysLoading(false);
                });
        }
    }, [store?.id]);

    useEffect(() => {
        if (Array.isArray(cards) && cards.length > 0) {
            const newOptions = cards.map((card) => {
                const { bankInfo } = BankCardRecognizer((card.cardNumber + ""));
                return { value: card.cardNumber, label: card.cardNumber, icon: bankInfo.icon };
            });
            setOptions(newOptions);
        } else {
            setOptions([]);
        }
    }, [cards]);

    useEffect(() => {
        setChatId(ChatId);
    }, [ChatId]);

    // منطق تایمر کارت به کارت
    useEffect(() => {
        let interval = null;
        if (isCardToCardPermitted && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0 && isCardToCardPermitted) {
            setIsCardToCardPermitted(false);
            toast.error("زمان شما برای پرداخت به پایان رسید. لطفاً مجدداً تلاش کنید.", { rtl: true });
        }
        return () => clearInterval(interval);
    }, [isCardToCardPermitted, timer]);

    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60).toString().padStart(2, '0');
        const s = (seconds % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    };

    const fn_sourceCard = (input) => {
        input && setSourceCard(input.value + "");
    };

    const fn_showRegister = () => {
        setIsShowRegister(!isShowRegister);
    };

    const toFa = (n, isCurrency = false) => {
        if (n === undefined || n === null) return '';
        if (isCurrency || typeof n === 'number') {
            const str = Number(n).toLocaleString('en-US');
            return str.replace(/[0-9]/g, c => String.fromCharCode(c.charCodeAt(0) + 1728));
        }
        return n.toString().replace(/[0-9]/g, c => String.fromCharCode(c.charCodeAt(0) + 1728));
    };

    const totalQuantity = cartItems.reduce((o, c) => o + c.quantity, 0) ?? 0;
    const totalVat = cartItems.reduce((o, c) => o + c.vat_price * c.quantity, 0) ?? 0;
    const totalPackCost = cartItems.reduce((o, c) => o + c.pack_cost * c.quantity, 0) ?? 0;
    const totalPriceConsumer = cartItems.reduce((o, c) => o + c.price * c.quantity, 0) ?? 0;
    const totalDiscount = cartItems.reduce((o, c) => o + c.discount_price * c.quantity, 0) ?? 0;
    const totalPriceOur = totalPriceConsumer - totalDiscount;

    let finalShippingCost = 0;
    if (shippingMethod) {
        if (shippingPaymentType === 'pre') {
            finalShippingCost = parseInt(shippingMethod.price || 0);
        } else {
            finalShippingCost = 0;
        }
    } else {
        finalShippingCost = parseInt(store?.send_cost_price ?? 0);
    }

    const totalPayment = totalPriceOur + totalVat + totalPackCost + finalShippingCost;

    const getBasePayload = () => {
        const details_push = cartItems.map(item => ({
            amount: item.quantity,
            price: item.price,
            totalPrice: item.totalPrice,
            discount_price: item.discount_price,
            vat_price: item.vat_price,
            pack_cost: item.pack_cost,
            description: item.title,
            commodityName: item.title,
            id_commodity: item.id,
            id_property: item.variant_id,
            invoicePrice: item.invoicePrice
        }));

        return {
            "header": {
                business_id: store["id"],
                chatId: chatId,
                address: Address,
                post_code: Postcode,
                description: orderNote,
                totalInvoicePrice: totalPayment,
                gateway: paymentChoice,
                id_post_center: shippingMethod ? shippingMethod.id : 1,
                send_cost_price: finalShippingCost,
                shipping_payment_type: shippingPaymentType
            },
            "details": details_push,
            "cardinfo": {}
        };
    };

    const handleAuthError = (responseData, status) => {
        const msg = responseData?.message || "";

        if (
            status === 401 ||
            msg.includes("اطلاعات هویتی") ||
            msg.includes("تکمیل نمایید")
        ) {
            Swal.fire({
                title: 'نیاز به تکمیل اطلاعات',
                html: `<div style="font-size: 0.95rem; line-height: 1.8; color: #444;">${msg || 'برای ادامه خرید، اطلاعات خود را تکمیل کنید.'}</div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#007aff',
                cancelButtonColor: '#e5e5ea',
                confirmButtonText: '<span style="font-weight: bold;font-size:0.75rem">تکمیل اطلاعات</span>',
                cancelButtonText: '<span style="color: #1c1c1e; font-weight: bold;font-size:0.75rem">انصراف</span>',
                reverseButtons: false,
                width: '85%',
                padding: '2em 1em',
                backdrop: `rgba(0,0,0,0.4)`,
                didOpen: () => {
                    const confirmBtn = Swal.getConfirmButton();
                    const cancelBtn = Swal.getCancelButton();

                    if (confirmBtn) {
                        confirmBtn.style.borderRadius = '10px';
                        confirmBtn.style.padding = '12px 24px';
                        confirmBtn.style.minWidth = '110px';
                    }
                    if (cancelBtn) {
                        cancelBtn.style.borderRadius = '10px';
                        cancelBtn.style.padding = '12px 24px';
                        cancelBtn.style.minWidth = '110px';
                    }
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    setIsShowRegister(true);
                }
            });
            return true;
        }
        return false;
    };

    const handleMainAction = (e) => {
        e.preventDefault();

        if (paymentChoice === 0) {
            toast.error("روش پرداخت را انتخاب نمائید", { rtl: true });
            return;
        }

        if (paymentChoice === 1 && !isCardToCardPermitted) {
            requestPaymentPermission();
            return;
        }

        submitFinalPayment();
    };

    const requestPaymentPermission = () => {
        setPaymentClick(true);
        const data = getBasePayload();

        let loadingToastId = toast.loading("در حال بررسی موجودی و دریافت مجوز پرداخت...", { rtl: true });

        api.post(`invoice/store`, data)
            .then((response) => {
                toast.dismiss(loadingToastId);

                if (response.data.success) {
                    setIsCardToCardPermitted(true);
                    setPaymentHash(response.data.data.authority);
                    setTimer(600);
                    toast.success("مجوز پرداخت صادر شد. فرم مشخصات را تکمیل کنید.", { rtl: true });
                } else {
                    if (!handleAuthError(response.data, response.status)) {
                        if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                            response.data.data.forEach(err => toast.error(err, { rtl: true }));
                        } else if (response.data.message) {
                            toast.error(response.data.message, { rtl: true });
                        } else {
                            toast.error("امکان پرداخت در حال حاضر وجود ندارد.", { rtl: true });
                        }
                    }
                }
            })
            .catch(err => {
                toast.dismiss(loadingToastId);
                console.error(err);

                const errorData = err.response?.data;
                const status = err.response?.status;

                if (!handleAuthError(errorData, status)) {
                    if (errorData && Array.isArray(errorData.data) && errorData.data.length > 0) {
                        errorData.data.forEach(msg => toast.error(msg, { rtl: true }));
                    } else if (errorData && errorData.message) {
                        toast.error(errorData.message, { rtl: true });
                    } else {
                        toast.error("خطا در برقراری ارتباط با سرور", { rtl: true });
                    }
                }
            })
            .finally(() => {
                setPaymentClick(false);
            });
    };

    const submitFinalPayment = () => {
        if (paymentChoice === 1) {
            const rawCard = String(destinationCard || "").trim();

            if (!rawCard || rawCard.length !== 16) {
                toast.error("شماره کارت پرداخت‌کننده باید دقیقاً ۱۶ رقم باشد.", { rtl: true });
                return;
            }

            if (!isValidCardNumber(rawCard)) {
                toast.error("شماره کارت پرداخت‌کننده فاقد اعتبار است. لطفاً اصلاح کنید.", { rtl: true });
                return;
            }

            if (!payer || !String(payer).trim()) {
                toast.error("لطفاً نام پرداخت‌کننده را وارد کنید.", { rtl: true });
                return;
            }

            if (!trackingCode || !String(trackingCode).trim()) {
                toast.error("لطفاً کد پیگیری پرداخت را وارد کنید.", { rtl: true });
                return;
            }
        }

        setPaymentClick(true);
        let endpoint = "";
        let finalData = {};
        let loadingToastId = null;

        if (paymentChoice === 1) {
            endpoint = `invoice/card2card/store`;
            finalData = {
                payer: payer,
                trackingCode: trackingCode,
                description: description,
                totalPrice: totalPayment,
                source_card: sourceCard,
                destination_card: String(destinationCard),
                authority: paymentHash
            };
            loadingToastId = toast.loading("درحال ثبت اطلاعات پرداخت...", { rtl: true });
        } else {
            // پرداخت آنلاین (زرین‌پال = ۲ یا زیبال = ۳)
            endpoint = `invoice/store`;
            finalData = getBasePayload();
            loadingToastId = toast.loading("درحال انتقال به درگاه پرداخت...", { rtl: true });
        }

        api.post(endpoint, finalData)
            .then((response) => {
                if (response.data.success) {
                    try {
                        const currentBaskets = JSON.parse(localStorage.getItem("baskets") || "[]");
                        const updatedBaskets = Array.isArray(currentBaskets) ? currentBaskets.filter((basket) => basket.id !== store.id) : [];
                        localStorage.setItem("baskets", JSON.stringify(updatedBaskets));
                    } catch (e) {
                        console.error("Error updating baskets:", e);
                    }

                    if (paymentChoice === 2 || paymentChoice === 3) {
                        window.location.replace(response.data.data);
                    } else {
                        if (loadingToastId) toast.dismiss(loadingToastId);

                        setReceiptData({
                            title: "خرید از " + (store?.title || "فروشگاه"),
                            date: new Date(),
                            trackingCode: trackingCode,
                            price: totalPayment
                        });
                        setShowReceiptModal(true);
                    }
                } else {
                    if (loadingToastId) toast.dismiss(loadingToastId);

                    if (!handleAuthError(response.data, response.status)) {
                        if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                            response.data.data.forEach(err => toast.error(err, { rtl: true }));
                        } else if (response.data.message) {
                            toast.error(response.data.message, { rtl: true });
                        }
                    }

                    setPaymentClick(false);
                }
            })
            .catch(err => {
                if (loadingToastId) toast.dismiss(loadingToastId);
                console.error(err);

                const errorData = err.response?.data;
                const status = err.response?.status;

                if (!handleAuthError(errorData, status)) {
                    if (errorData && Array.isArray(errorData.data) && errorData.data.length > 0) {
                        errorData.data.forEach(msg => toast.error(msg, { rtl: true }));
                    } else if (errorData && errorData.message) {
                        toast.error(errorData.message, { rtl: true });
                    } else {
                        toast.error("خطا در برقراری ارتباط با سرور", { rtl: true });
                    }
                }

                setPaymentClick(false);
            });
    };

    const { bankInfo: bankInfo_destination } = BankCardRecognizer(destinationCard + "");

    const getButtonTitle = () => {
        if (paymentChoice === 1 && isCardToCardPermitted) {
            return "پرداخت کردم";
        }
        return "ادامه فرآیند خرید";
    };

    const handleCopyCard = () => {
        if (sourceCard) {
            navigator.clipboard.writeText(sourceCard)
                .then(() => {
                    toast.success("شماره کارت کپی شد!", { rtl: true });
                })
                .catch(() => {
                    toast.error("خطا در کپی کردن شماره کارت", { rtl: true });
                });
        }
    };

    const destCardStr = String(destinationCard || "");
    const isDestCardLength16 = destCardStr.length === 16;
    const isDestCardValid = isDestCardLength16 && isValidCardNumber(destCardStr);

    return (
        <>
            {(!store || cartItems.length === 0) && <Navigate to="/" replace={true} />}
            <div className='shop-payment' style={{ backgroundColor: bgLight || '#F9F9F9', minHeight: '100vh' }}>

                {/* --- HEADER --- */}
                <div className="topbar">
                    <TelegramSafeArea style={{ background: "transparent", color: "#000" }}>
                        <div
                            className="safe-area-title"
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                lineHeight: '1.3'
                            }}
                        >
                            {store?.title ? (
                                <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{store.title}</span>
                            ) : (
                                <div className="skeleton-shimmer" style={{ width: '80px', height: '14px', borderRadius: '4px', marginBottom: '4px' }}></div>
                            )}

                            {store?.message ? (
                                <span style={{ fontSize: '12px', opacity: 0.85 }}>{store.message}</span>
                            ) : store ? null : (
                                <div className="skeleton-shimmer" style={{ width: '120px', height: '10px', borderRadius: '4px' }}></div>
                            )}
                        </div>
                    </TelegramSafeArea>

                    <StoreBanner store={store} />

                    <div className="header" style={{ color: color, background: "transparent" }}>
                        <div className="title">فاکتور شما</div>
                        <Link to="/ShopDelivery" state={{ ...location.state }}>
                            <div className="back">
                                <div className="btn-back"><IoMdArrowRoundBack size={"25px"} /></div>
                            </div>
                        </Link>
                    </div>
                </div>

                {/* --- BODY --- */}
                <div className="body-shop">
                    <div className="wrraper-shop">

                        {/* --- INVOICE TABLE --- */}
                        <div className="invoice-preview">
                            <div className="invoice-table-header">
                                <div className="col-desc">شرح کالا/خدمات</div>
                                <div className="col-count">تعداد</div>
                                <div className="col-price-orig">قیمت کالا</div>
                                <div className="col-price-ours">قیمت ما</div>
                                <div className="col-total">مبلغ کل</div>
                            </div>

                            {cartItems.map((item, index) => (
                                <div className="invoice-item-row" key={index}>
                                    <div className="col-desc">{toFa(item.title)}</div>
                                    <div className="col-count">{toFa(item.quantity)}</div>
                                    <div className="col-price-orig">{toFa(item.price, true)}</div>
                                    <div className="col-price-ours">{toFa(item.price - item.discount_price, true)}</div>
                                    <div className="col-total">{toFa(item.totalPrice2, true)}</div>
                                </div>
                            ))}

                            <div className="invoice-divider"></div>

                            <div className="invoice-summary">
                                <div className="summary-row">
                                    <span>مجموع قیمت مصرف کننده:</span>
                                    <span>{toFa(totalPriceConsumer, true)}</span>
                                </div>
                                <div className="summary-row profit-row">
                                    <span>سود شما از این خرید:</span>
                                    <span>{toFa(totalDiscount, true)}</span>
                                </div>
                                <div className="summary-row">
                                    <span>ارزش افزوده:</span>
                                    <span>{toFa(totalVat, true)}</span>
                                </div>
                                <div className="summary-row">
                                    <span>هزینه بسته بندی و ارسال:</span>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                        <span>
                                            {toFa(totalPackCost + finalShippingCost, true)}
                                        </span>
                                        {shippingPaymentType === 'after' && (
                                            <span style={{ fontSize: '11px', color: '#ef394e', marginTop: '3px' }}>
                                                (هزینه ارسال: پس‌کرایه - پرداخت در محل)
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="total-pay-row">
                                    <span>مبلغ قابل پرداخت (تومان):</span>
                                    <span className="total-amount">{toFa(totalPayment, true)}</span>
                                </div>
                            </div>
                        </div>

                        {/* --- ADDRESS INFO --- */}
                        <div className="info-box address-compact-container">
                            <div className="address-row">
                                <span className="row-label">آدرس:</span>
                                <span className="row-value">{toFa(Address)}</span>
                            </div>

                            <div className="address-row">
                                <span className="row-label">کد پستی:</span>
                                <span className="row-value">{toFa(Postcode)}</span>
                            </div>

                            <div className="order-note-container">
                                <span className="row-label note-label">یادداشت سفارش (اختیاری):</span>
                                <textarea
                                    className="order-note-input"
                                    placeholder="اگر توضیح یا درخواست خاصی دارید، اینجا بنویسید..."
                                    value={orderNote}
                                    onChange={(e) => setOrderNote(e.target.value)}
                                    rows="2"
                                />
                            </div>
                        </div>

                        {/* --- PAYMENT METHODS (آیکون در چپ، رادیو و متن در راست) --- */}
                        {/* --- PAYMENT METHODS (آیکون و متن در راست، رادیوباتون در چپ) --- */}
                        <div className="info-box">
                            <div className="info-box-title" style={{ color: 'red', textAlign: 'center', marginBottom: '15px' }}>روش پرداخت</div>

                            {isGatewaysLoading ? (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px 0' }}>
                                    <ReactLoading type="bubbles" color={backgroundcolor || "#007aff"} height={50} width={60} />
                                    <span style={{ fontSize: '12px', color: '#777', marginTop: '8px' }}>درحال بارگذاری روش‌های پرداخت...</span>
                                </div>
                            ) : (
                                <>
                                    {hasCardToCard && (
                                        <label className={`btn-payment-portal ${paymentChoice === 1 ? "active" : ""}`}>
                                            {/* سمت راست: آیکون درگاه و متن */}
                                            <div className="portal-right-content">
                                                <div className="portal-icon-wrapper">
                                                    <img src={card2cardIcon} alt="کارت به کارت" />
                                                </div>
                                                <span className="radio-label-text">کـارت به کـارت</span>
                                            </div>

                                            {/* سمت چپ: دکمه رادیو */}
                                            <div className="portal-left-radio">
                                                <input
                                                    type="radio"
                                                    name="paymentGateway"
                                                    value={1}
                                                    checked={paymentChoice === 1}
                                                    onChange={() => {
                                                        setPaymentChoice(1);
                                                        setIsCardToCardPermitted(false);
                                                    }}
                                                />
                                            </div>
                                        </label>
                                    )}



                                    {hasZibal && (
                                        <label className={`btn-payment-portal ${paymentChoice === 3 ? "active" : ""}`}>
                                            {/* سمت راست: آیکون درگاه و متن */}
                                            <div className="portal-right-content">
                                                <div className="portal-icon-wrapper">
                                                    <img src={zibalIcon} alt="زیبال" />
                                                </div>
                                                <span className="radio-label-text">درگاه زیبال</span>
                                            </div>

                                            {/* سمت چپ: دکمه رادیو */}
                                            <div className="portal-left-radio">
                                                <input
                                                    type="radio"
                                                    name="paymentGateway"
                                                    value={3}
                                                    checked={paymentChoice === 3}
                                                    onChange={() => {
                                                        setPaymentChoice(3);
                                                        setIsCardToCardPermitted(false);
                                                    }}
                                                />
                                            </div>
                                        </label>
                                    )}
                                    {hasZarinpal && (
                                        <label className={`btn-payment-portal ${paymentChoice === 2 ? "active" : ""}`}>
                                            {/* سمت راست: آیکون درگاه و متن */}
                                            <div className="portal-right-content">
                                                <div className="portal-icon-wrapper">
                                                    <img src={zarinpalIcon} alt="زرین پال" />
                                                </div>
                                                <span className="radio-label-text">درگاه زرین پال</span>
                                            </div>

                                            {/* سمت چپ: دکمه رادیو */}
                                            <div className="portal-left-radio">
                                                <input
                                                    type="radio"
                                                    name="paymentGateway"
                                                    value={2}
                                                    checked={paymentChoice === 2}
                                                    onChange={() => {
                                                        setPaymentChoice(2);
                                                        setIsCardToCardPermitted(false);
                                                    }}
                                                />
                                            </div>
                                        </label>
                                    )}
                                    
                                    {!hasAnyGateway && (
                                        <div style={{ textAlign: 'center', color: '#666', padding: '15px', backgroundColor: '#f8d7da', borderRadius: '8px', border: '1px solid #f5c6cb' }}>
                                            متاسفانه هیچ روش پرداختی برای این فروشگاه فعال نیست.
                                        </div>
                                    )}
                                </>
                            )}
                        </div>


                        {/* --- CARD TO CARD FORM --- */}
                        {paymentChoice === 1 && isCardToCardPermitted && !isGatewaysLoading && (
                            <div className="cardTocard-payment">
                                <div className="timer-box">
                                    زمان باقیمانده برای پرداخت: <span>{toFa(formatTime(timer))}</span>
                                </div>

                                <div className="account-business">
                                    <div className="title">انتخاب کارت فروشنده:</div>
                                    <div className="cards" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1, position: 'relative' }}>
                                            <CustomSelect options={options} fn_fill={fn_sourceCard} />
                                            <span className="select-arrow"><FaChevronDown color="#777" size={14} /></span>
                                        </div>

                                        {sourceCard && (
                                            <div
                                                onClick={handleCopyCard}
                                                style={{
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '10px',
                                                    backgroundColor: '#f1f5f9',
                                                    borderRadius: '8px',
                                                    border: '1px solid #e2e8f0'
                                                }}
                                                title="کپی شماره کارت"
                                            >
                                                <FaRegCopy size={20} color="#64748b" />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="buyer-payment">
                                    <div className="title">اطلاعات پرداختی</div>

                                    <div className="item-cardtocard">
                                        <div className="item-title">نام پرداخت کننده:</div>
                                        <div className="item-input">
                                            <input
                                                type='text'
                                                placeholder='نام پرداخت کننده'
                                                required
                                                value={payer}
                                                onChange={(e) => setPayer(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="item-cardtocard">
                                        <div className="item-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <span>شماره کارت پرداخت کننده:</span>
                                            {destCardStr.length > 0 && (
                                                <span style={{
                                                    fontSize: '11px',
                                                    fontWeight: 'bold',
                                                    padding: '2px 8px',
                                                    borderRadius: '4px',
                                                    backgroundColor: !isDestCardLength16
                                                        ? '#f3f4f6'
                                                        : (isDestCardValid ? '#e6f4ea' : '#fce8e6'),
                                                    color: !isDestCardLength16
                                                        ? '#6b7280'
                                                        : (isDestCardValid ? '#137333' : '#c5221f'),
                                                    border: `1px solid ${!isDestCardLength16 ? '#e5e7eb' : (isDestCardValid ? '#b7e1cd' : '#fad2cf')}`
                                                }}>
                                                    {!isDestCardLength16
                                                        ? `${destCardStr.length} از ۱۶ رقم`
                                                        : (isDestCardValid ? '✔ معتبر' : '✖ فاقد اعتبار')}
                                                </span>
                                            )}
                                        </div>

                                        <div className="item-input">
                                            <NumericFormat
                                                placeholder='شماره کارت'
                                                isAllowed={(values) => {
                                                    const { value } = values;
                                                    return value.length <= 16;
                                                }}
                                                value={destinationCard}
                                                onValueChange={(values) => {
                                                    setDestinationCard(values.value || "");
                                                }}
                                            />
                                            {bankInfo_destination && (
                                                <div className="icon">
                                                    <img src={process.env.PUBLIC_URL + bankInfo_destination.icon} alt="bank" />
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="item-cardtocard">
                                        <div className="item-title">کد پیگیری پرداخت:</div>
                                        <div className="item-input">
                                            <input
                                                type='text'
                                                inputMode='numeric'
                                                placeholder='کد پیگیری'
                                                required
                                                value={trackingCode}
                                                onChange={(e) => {
                                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                                    setTrackingCode(numericValue);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="item-cardtocard">
                                        <div className="item-title">توضیحات:</div>
                                        <div className="item-input">
                                            <input
                                                type='text'
                                                placeholder='توضیحات'
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* --- SUBMIT BUTTON --- */}
                        <div className="btn-submit-container">
                            <button
                                className={`btn_payment_final btn-submit ${paymentClick ? "loading-mode" : ""}`}
                                onClick={handleMainAction}
                                disabled={isGatewaysLoading || !hasAnyGateway || paymentClick}
                                style={{
                                    backgroundColor: backgroundcolor,
                                    opacity: (isGatewaysLoading || !hasAnyGateway) ? 0.6 : 1,
                                    cursor: (isGatewaysLoading || !hasAnyGateway) ? 'not-allowed' : 'pointer'
                                }}
                            >
                                <span>{getButtonTitle()}</span>
                                {paymentClick && (
                                    <div className="spinner-wrapper" style={{ marginRight: '10px' }}>
                                        <ReactLoading type="spin" color="#FFF" height={20} width={20} />
                                    </div>
                                )}
                            </button>
                        </div>

                    </div>
                </div>

            </div>

            {/* --- RECEIPT MODAL --- */}
            {showReceiptModal && receiptData && (
                <div className="modal-overlay" style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center',
                    alignItems: 'center', zIndex: 9999
                }}>
                    <div className="payment-container" style={{ transform: 'scale(0.9)' }}>
                        <div className="receipt-card">
                            <div className="receipt-header">
                                <div className="icon-circle success-bg">
                                    <svg className="status-icon" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M5 13L9 17L19 7" />
                                    </svg>
                                </div>
                                <h2 className="status-text success-text">ثبت موفق فیش بانکی</h2>
                                <p className="sub-status">اطلاعات پرداختی شما با موفقیت ثبت شد و در انتظار تایید فروشگاه است.</p>
                                <p className="payment-title">{receiptData.title}</p>
                            </div>

                            <div className="dashed-line"></div>

                            <div className="receipt-body">
                                <div className="info-row">
                                    <span className="label">زمان ثبت :</span>
                                    <span className="value" style={{ textAlign: "right" }}>
                                        {toFa(new Date(receiptData.date).toLocaleDateString('fa-IR'))}
                                    </span>
                                </div>

                                <div className="info-row">
                                    <span className="label">کد پیگیری :</span>
                                    <span className="value">{toFa(receiptData.trackingCode)}</span>
                                </div>

                                <div className="amount-box">
                                    <span>مبلغ :</span>
                                    <span className="amount-value">{toFa(receiptData.price, true)} تومان</span>
                                </div>
                            </div>

                            <div className="dashed-line"></div>

                            <div className="receipt-footer">
                                <button onClick={() => window.location.replace("/Shop")} className="btn primary-btn" style={{ width: '100%', marginBottom: '10px' }}>
                                    بازگشت به فروشگاه
                                </button>
                                <button onClick={() => {
                                    sessionStorage.removeItem("store");
                                    window.location.replace("/Report");
                                }} className="btn" style={{ width: '100%', marginBottom: '10px', backgroundColor: '#e2e8f0', color: '#333', border: 'none' }}>
                                    پیگیری سفارش
                                </button>
                            </div>
                            <div className="jagged-edge"></div>
                        </div>
                    </div>
                </div>
            )}

            <Suspense fallback={null}>
                {isShowRegister && (
                    <Register fn_close={fn_showRegister} isShow={isShowRegister} />
                )}
            </Suspense>
        </>
    );
}

export default ShopPayment;
